// 强制 Service Worker 更新:用户每次刷新,新版本立即生效
if ('serviceWorker' in navigator) {
  // 页面加载完成后,主动 unregister 旧 SW,确保所有资源走网络
  window.addEventListener('load', async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const reg of regs) {
        // 主动跳过等待
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        // 让新 SW 立即接管
        reg.update();
      }
    } catch (e) {
      console.warn('SW update failed:', e);
    }
  });
}
